<div class="bmc-working-time-schema-viewer">
  <bs-datepicker-inline [bsConfig]="bsConfig" [dateCustomClasses]="datesCustomUserCalendarView" (mouseout)="onLeave()" (mouseover)="onOver($event)"></bs-datepicker-inline>
</div>
<div *ngIf="showDetail">
  <working-time-schema-popup [top]="location_top" [left]="location_left" [workingTimeSchema]="workingTimeSchema" [isCompany]="isCompany"></working-time-schema-popup>
</div>


